'use client';

import { c as _c } from "react/compiler-runtime";
import { Input, InputGroupInput } from '@repo/ui/components/start';
import { usePhoneInput } from './context';
export interface PhoneInputFieldProps extends Omit<React.ComponentProps<'input'>, 'defaultValue' | 'onChange' | 'type' | 'value'> {
  placeholder?: string;
}
export function PhoneInputField(t0) {
  const $ = _c(26);
  let className;
  let props;
  let ref;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      placeholder: t1,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = t1;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    t1 = $[4];
  }
  const placeholder = t1 === undefined ? "-" : t1;
  const {
    actions,
    state
  } = usePhoneInput();
  const {
    disabled,
    inputVariant,
    layout,
    value
  } = state;
  if (layout === "input-group") {
    let t2;
    if ($[5] !== actions) {
      t2 = e => actions.setValue(e.target.value);
      $[5] = actions;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== className || $[8] !== disabled || $[9] !== placeholder || $[10] !== props || $[11] !== ref || $[12] !== t2 || $[13] !== value) {
      t3 = <InputGroupInput className={className} disabled={disabled} inputMode="tel" onChange={t2} placeholder={placeholder} ref={ref} value={value} {...props} />;
      $[7] = className;
      $[8] = disabled;
      $[9] = placeholder;
      $[10] = props;
      $[11] = ref;
      $[12] = t2;
      $[13] = value;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    return t3;
  }
  let t2;
  if ($[15] !== actions) {
    t2 = e_0 => actions.setValue(e_0.target.value);
    $[15] = actions;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== className || $[18] !== disabled || $[19] !== inputVariant || $[20] !== placeholder || $[21] !== props || $[22] !== ref || $[23] !== t2 || $[24] !== value) {
    t3 = <Input className={className} disabled={disabled} inputMode="tel" onChange={t2} placeholder={placeholder} ref={ref} value={value} variant={inputVariant} {...props} data-sentry-element="Input" data-sentry-component="PhoneInputField" data-sentry-source-file="field.tsx" />;
    $[17] = className;
    $[18] = disabled;
    $[19] = inputVariant;
    $[20] = placeholder;
    $[21] = props;
    $[22] = ref;
    $[23] = t2;
    $[24] = value;
    $[25] = t3;
  } else {
    t3 = $[25];
  }
  return t3;
}